import { render } from "./DiscountButton.vue?vue&type=template&id=23b1db38"
import script from "./DiscountButton.vue?vue&type=script&lang=js"
export * from "./DiscountButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__